<template>
	<UiElement class="position-sticky top-0 start-0 d-flex justify-content-between align-items-center z-3" :settings="page.appearance.body.settings">
		<div class="position-relative">
			<div v-if="hideBtn1" class="position-absolute w-100 h-100 z-1" :style="`background: ${page.appearance.body.settings.background[0]}`" />

			<router-link :to="`/${route?.params?.kioskId}/cancel-order`" class="text-decoration-none">
				<UiButton :settings="headerButton1 || headerButton1SettingsFallback">
					{{ translations?.cancel || '{cancel}' }}
				</UiButton>
			</router-link>
		</div>

		<div style="width:230px">
			<img
				v-if="general?.elements?.logo?.settings?.image"
				:src="general.elements.logo.settings.image"
				class="w-100 h-100"
				alt=""
			/>

			<img
				v-else
				src="/images/logo_fallbach.png"
				class="w-100 h-100"
				alt=""
			/>
		</div>

		<div></div>

		<UiButtonLanguage :settings="headerButton2 || headerButton2SettingsFallback" />
	</UiElement>
</template>
<script setup>
	import { defineProps, computed } from 'vue';
	import { storeToRefs } from 'pinia';
	import { useThemeStore } from '@/stores/useThemeStore';
	import UiElement from '@/components/UI/UiElement.vue';
	import UiButton from '@/components/UI/UiButton.vue';
	import UiButtonLanguage from '@/components/UI/UiButtonLanguage.vue';
	import { useInheritedSettings } from '@/composables/useInheritedSettings';
	import { useTranslationsStore } from '@/stores/useTranslationsStore';
	import { useRoute } from 'vue-router';

	const themeStore = useThemeStore();
	const translationsStore = useTranslationsStore();

	const { translations } = storeToRefs(translationsStore);
	const { theme } = storeToRefs(themeStore);
	const route = useRoute();

	defineProps({
		logo: {
			type: Object,
			default: null
		},
		headerButton1: {
			type: Object,
			default: null
		},
		headerButton2: {
			type: Object,
			default: null
		},
		hideBtn1: {
			type: Boolean,
			default: false
		}
	});

	const page = computed(() => theme.value.pages.header);
	const general = computed(() => theme.value.general);
	const elements = computed(() => page.value.elements);
	// const logoSettingsFallback = useInheritedSettings(computed(() => elements.value?.logo));
	const headerButton1SettingsFallback = useInheritedSettings(computed(() => elements.value?.headerButton1));
	const headerButton2SettingsFallback = useInheritedSettings(computed(() => elements.value?.headerButton2));
</script>